<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 21" fill="none">
    <path d="M16.75 10.5C16.75 14.228 13.728 17.25 10 17.25C6.27208 17.25 3.25 14.228 3.25 10.5C3.25 6.77208 6.27208 3.75 10 3.75C13.728 3.75 16.75 6.77208 16.75 10.5Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.25 9.75H10V13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 6.9375C10.3106 6.9375 10.5625 7.18934 10.5625 7.5C10.5625 7.81066 10.3106 8.0625 10 8.0625C9.68935 8.0625 9.4375 7.81066 9.4375 7.5C9.4375 7.18934 9.68935 6.9375 10 6.9375Z" 
    fill="currentColor" stroke="currentColor" stroke-width="0.375"/>
  </svg>
</template>

<script>
export default {
  name: 'DetailsIcon',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    }
  }
}
</script>

<style scoped></style>